/* esm.sh - applesauce-common@5.2.0/dist/blueprints/note */
export * from "/*applesauce-common@5.2.0/esnext/dist/blueprints/note.mjs";
